import FullLoader from "components/loader/full-loader";
import { useInvoice } from "contexts/v1/pages/InvoiceContext";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import LayoutDashboard from "layouts/layout-dashboard-collapse";
import React, { useState } from "react";
import { Dropdown, Tab, Tabs } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { deleteRequest } from "services/api";
import Swal from "sweetalert2";
import { URLS } from "utils/constants";
import Recipients from "./components/recipients";
import { IconCalendar } from "@tabler/icons-react";
import { convertToHi, formatDateToDayMonthYear } from "utils/dateHelpers";
import { formatPrice } from "utils/utils";

const InvoicesPage = () => {
    const { invoices, Pagination, refetch } = useInvoice();

    console.log(invoices);

    const navigate = useNavigate();

    const [recipientsCanvas, setRecipientsCanvas] = useState({
        show: false,
        data: [],
    });

    const handleDelete = async (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                const response = await deleteRequest(`/invoice/${id}`);

                if (response.success) {
                    Swal.fire({
                        icon: "success",
                        title: "Deleted!",
                        text: 'Invoice deleted successfully',
                    });
                    refetch();
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: 'Failed to delete invoice'
                    });
                }
            }
        });
    };

    const handleUpdate = (e, data) => {
        e.stopPropagation();
        navigate(URLS.v1.INVOICES + '/' + data.id + '/edit');
    };

    if (invoices.loading) {
        return (<FullLoader />);
    }

    return (
        <LayoutDashboard>
            <div className="container-fluid mt-5">
                <div className="table-container">
                    <div className="search-container mb-3">
                        {/* Search input */}
                        <SearchInput />

                        {/* Create button */}
                        <button className="btn btn-primary" onClick={() => {
                            navigate(URLS.v1.INVOICES + '/create');
                        }}>Create</button>
                    </div>

                    {/* Table */}
                    <div className="table">
                        <table className="table table-hover table-vcenter">
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>Name</th>
                                    <th>Customer</th>
                                    <th>Recipients</th>
                                    <th>Reminder Type</th>
                                    <th>Reminder</th>
                                    <th>Grand Total</th>
                                    <th className="text-end">Actions</th>
                                </tr>
                            </thead>
                            {invoices.data.length > 0 ? (
                                <tbody>
                                    {invoices.data.map((data, index) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <tr>
                                                    <td>
                                                        {index + 1}
                                                    </td>
                                                    <td>{data.name}</td>
                                                    <td>{data.customer && data.customer.name}</td>
                                                    <td>{data.recipients.length}</td>
                                                    <td>{data.recurring_type}</td>
                                                    <td>
                                                        <span className="d-block">Due Date</span>
                                                        <IconCalendar className="me-2 text-secondary" size={20} />
                                                        {formatDateToDayMonthYear(data.due_date)}
                                                        <span className="d-block">Reminder</span>
                                                        <IconCalendar className="me-2 text-secondary" size={20} />
                                                        {data.reminder_date || data.reminder_time ? formatDateToDayMonthYear(data.reminder_date) + ' ' + (data.reminder_time && convertToHi(data.reminder_time)) : '-'}
                                                    </td>
                                                    <td>{formatPrice(data.grand_total)}</td>
                                                    <td className="text-end">
                                                        <Dropdown>
                                                            <Dropdown.Toggle variant="default" id="dropdownMenuButton1">
                                                                Actions
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                <Dropdown.Item href="#" onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setRecipientsCanvas({
                                                                        show: true,
                                                                        data: data.recipients,
                                                                    });
                                                                }
                                                                }>Recipients</Dropdown.Item>
                                                                <Dropdown.Item href="#" onClick={() => {
                                                                    navigate(URLS.v1.INVOICES + '/' + data.id + '/view');
                                                                }}>View</Dropdown.Item>
                                                                <Dropdown.Item href="#" onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    navigate(URLS.v1.INVOICES + '/history/' + data.id);
                                                                }}>History</Dropdown.Item>
                                                                <Dropdown.Item href="#" onClick={(e) => handleUpdate(e, data)}>Edit</Dropdown.Item>
                                                                <Dropdown.Item href="#" onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleDelete(data.id);
                                                                }}>
                                                                    Remove
                                                                </Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        )
                                    })}
                                </tbody>
                            ) : (
                                <tbody>
                                    <tr>
                                        <td colSpan="8" className="text-center">No data</td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="mt-4">
                        {Pagination}
                    </div>

                    {/* Recipients */}
                    <Recipients recipientsCanvas={recipientsCanvas} setRecipientsCanvas={setRecipientsCanvas} />
                </div>
            </div>
        </LayoutDashboard>
    )
}

export default InvoicesPage;

const SearchInput = () => {
    const { handleSearch, filterOptions } = useInvoice();
    const [search, setSearch] = useState(filterOptions.search || '');

    return (
        <div className="input-icon">
            <input type="text" className="form-control" placeholder="Search..." value={search} onChange={(e) => setSearch(e.target.value)} onKeyDown={handleSearch} />
            <span className="input-icon-addon">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-search"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <circle cx="10" cy="10" r="7" />
                    <line x1="21" y1="21" x2="15" y2="15" />
                </svg>
            </span>
        </div>
    )
};